import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable, of } from 'rxjs';
import { CommonResponse } from 'src/app/models/core.model';
import { CheckoutFailureReason } from 'src/app/models/checkout.model';
import { EmploymentInformation } from '../interfaces/employment-information';
import { PreAppModel } from '../interfaces/playground.model';
import { ModifyCardOffer, ModifyComboOffer, ModifyLoan } from '../interfaces/offers-model';

@Injectable({ providedIn: 'root' })
export class BackendService extends HttpService {
  LoginRequest(civilId: string, product?: any, referPage?: string, sessionId: string = '') {
    let trackingId = sessionStorage.getItem('journeyTrackingId');
    let pId = Number(sessionStorage.getItem('PId'));
    console.log(trackingId)
   
    let headers = new HttpHeaders().set('Authorization', `ignore`).set('SessionId', sessionId);
    let body: any = {
      civilId,
      uuid: this.session.clientId,
      language: this.language,
      ...(pId && { 'PId': pId })
    };
    if(trackingId) {
      body.JourneyTrackingId = JSON.parse(JSON.stringify(trackingId))
    }
    // Add product to the body if it's provided
    if (product) {
      body.product = product;
    }
    // Add referPage to the body if it's provided
    if (referPage) {
      body.referPage = referPage;
    }

    let api: string;
    if (this.session.calculateEligibilityFirst)
      api = 'civil-id'
    else
      api = 'LoginRequest'

    return this.doPost('Authenticate/' + api, body, { headers });
  }

  RegisterApplicant(body: any) {
    return this.doPost('Customer/Register', body);
  }

  SetPinCode(passcode: string) {
    return this.doPost('Customer/SetPinCode', {
      password: passcode,
    });
  }
  UpdatePassword(appId: string, passcode: string) {
    return this.doPost('Application/UpdatePassword', {
      AppId: appId,
      password: passcode
    });
  }
  SendOTP() {
    return this.doGet('Customer/SendOTP');
  }

  // ActivateProfile(otp: number) {
  //   return this.doPost('Customer/ActivateProfile', {
  //     otp,
  //   });
  // }

  LogIn(civilId: string, passcode: string) {
    let rawString = btoa(`${civilId},${this.session.clientId}:${passcode}`);
    return this.doGet('Authenticate/login', {
      headers: new HttpHeaders().set('Authorization', `Basic ${rawString}`),
      params: new HttpParams().set('Language', this.language),
    });
  }
  loginWithoutOTP(civilId: string, passcode: string) {
    let rawString = btoa(`${civilId},${this.session.clientId}:${passcode}`);
    return this.doGet('Application/PassValidation', {
      params: new HttpParams()
        .set('Language', this.language)
        .set('Token', `${rawString}`),
    });
  }

  changePassword(password: string) {
    let rawString = btoa(`${this.session.clientId}:${password}`);
    return this.doGet('TasheelAuth/ChangePassword', {
      params: new HttpParams().set('Token', `${rawString}`),
    });
  }
  updateSession(otp: any) {
    return this.doPost('TasheelAuth/UpdateSession', otp);
  }

  validateOtp(data: { otp: number, utmId?: number, journeyTrackingId?: string, PId?: number }) {
    let api: string;
    if (this.session.calculateEligibilityFirst)
      api = 'login-otp'
    else
      api = 'LoginAuth'
    return this.doPost('Authenticate/' + api, data);
  }

  checkEligibility(data: PreAppModel): any {
    return this.doPost('eligibility/check-initial-eligibility', data);
  }

  IsNewMobileNumber(mobileNumber: string) {
    let params = new HttpParams().set('MobileNo', mobileNumber);
    return this.doGet('Customer/IsNewMobileNumber', {
      params,
    });
  }

  GetApprovedCompanies(keyword: string, employmentType: number = 0) {
    let params = new HttpParams()
      .set('keyword', keyword)
      .set('employmentType', employmentType.toString());

    return this.doGet('LookupAuth/GetApprovedCompanies', {
      params: params
    });
  }

  GetJobTitles(employerType: number) {
    let params = new HttpParams().set('EmploymentType', employerType);
    return this.doGet('LookupAuth/GetJobTitles', {
      params,
    });
  }
  UpdateJobTitle(AppId: string, JobTitleCode: number) {
    let params = new HttpParams().set('AppId', AppId)
      .set('JobTitleCode', JobTitleCode);
    return this.doGet('Application/UpdateJobTitle', {
      params,
    });
  }
  GetJobTitlesByAppId(AppId: string) {
    let params = new HttpParams().set('AppId', AppId);
    return this.doGet('Application/GetJobTitles', {
      params,
    });
  }
  GetCities() {
    return this.doGet('LookupAuth/GetCities');
  }

  GetRegion(latitude: any, longitude: any) {
    let params = new HttpParams()
      .set('latitude', latitude)
      .set('logitude', longitude);
    return this.doGet('Application/GetRegion', {
      params: params
    });
  }
  GetRegionId() {
    return this.doGet('Application/GetRegionId');
  }
  GetRegionWithNoSession(latitude: any, longitude: any) {
    let params = new HttpParams()
      .set('latitude', latitude)
      .set('logitude', longitude);
    return this.doGet('Lookup/GetRegion', {
      params: params
    });
  }

  GetBranchList() {
    return this.doGet('Lookup/GetBranchList');
  }

  UpdateBranch(latitude: any, longitude: any, storeId: any) {
    let params = new HttpParams()
      .set('latitude', latitude)
      .set('longitude', longitude)
      .set('storeId', storeId);
    return this.doGet('Lookup/UpdateBranch', {
      params: params
    });
  }

  GetBranchCities() {
    return this.doGet('LookupAuth/GetBranchCities');
  }

  GetRegions() {
    return this.doGet('LookupAuth/GetRegions');
  }
  GetRegionsWithNoSession() {
    let params;
    let lang = this.session.CurrentLang.IsLeft ? 2 : 1;
    params = new HttpParams().set('languageId', lang);
    return this.doGet('Lookup/GetRegions', { params });
  }

  GetMaritalStatuses() {
    return this.doGet('LookupAuth/GetMaritalStatues');
  }

  GetPurposeOfLoan() {
    return this.doGet('LookupAuth/GetPurposeOfLoan');
  }

  SavePurposeOfLoan(AppId: any, PurposeOfLoan: number) {
    let params = new HttpParams()
      .set('appId', AppId)
      .set('PurposeOfLoan', PurposeOfLoan);
    return this.doGet('Application/SavePurposeOfLoan', {
      params: params
    });
  }
  GetCountries() {
    return this.doGet('LookupAuth/GetCountries');
  }

  GetServiceDurations() {
    return this.doGet('LookupAuth/GetServiceDurations');
  }
  // GetResidenceType() {
  //   return this.doGet('LookupAuth/GetResidenceType');
  // }

  startApplicationEngine(appId: string, isResume: boolean) {
    let params;
    if (appId) {
      params = new HttpParams().set('AppId', appId);
      if (isResume)
        params = params.set('isResume', isResume);
    }
    else
      params = new HttpParams().set('Step', 1);
    return this.doGet('Application/ApplicationEngine', { params });
  }

  // PostApplication(body: any) {
  //   return this.doPost('Application/SubmitApplication', body);
  // }
  // SaveApplication(body: any) {
  //   return this.doPost('Application/SaveApplication', body);
  // }

  saveApp(body: any) {
    return this.doPost('Application/SaveApp', body);
  }
  submitApp(body: any) {
    return this.doPost('Application/SubmitApp', body);
  }

  // SavePreApp(body: any) {
  //   return this.doPost('Application/SavePreApp', body);
  // }
  // UpdatePreApp(body: any) {
  //   return this.doPost('Application/UpdatePreApp', body);
  // }
  LogAPIErrors(body: any) {
    return this.doPost('Dashboard/LogAPIErrors', body);
  }
  initApp(preId: number) {
    let params;
    params = new HttpParams().set('preId', preId);
    return this.doGet('Application/InitApp', { params });
  }

  SendInquery(body: any) {
    return this.doPost('Customer/PostPersonalDetails', body);
  }

  updateBirthDate(body: any) {
    return this.doPost('Application/UpdateBirthDate', body);
  }

  updateIdExpiryDate(body: any) {
    return this.doPost('CreditCard/update-card-kyc', body)
  }

  GetGosi(AppId: string) {
    let params = new HttpParams().set('AppId', AppId);
    return this.doGet('Application/GetGosi', { params });
  }

  ApplyInputSalary() {
    return this.doGet('Application/ApplyInputSalary');
  }
  ApplyGosiSalary() {
    return this.doGet('Application/ApplyGosiSalary');
  }
  ApplySalary(IsGosi: boolean, AppId: string) {
    let params = new HttpParams().set('AppId', AppId).set('IsGosi', IsGosi);
    return this.doGet('Application/ApplySalary', { params });
  }
  GetFinancialDetailByProduct(querystring: any) {
    return this.doGet('Application/financial-details' + querystring);
  }

  UpdateAppstaggingTenure(body: any) {
    return this.doPost(
      'Application/UpdateAppstaggingTenure?tenure=' +
      body.tenure +
      '&amount=' +
      body.amount,
      null
    );
  }
  GetAppstagging() {
    return this.doGet('Application/GetAppstagging');
  }

  // GetTokenFromOldLogin(IqamaNumber: string, Password: string) {
  //   let headers = new HttpHeaders()
  //     .set('Authorization', `ignore`)
  //     .set('Content-type', 'application/x-www-form-urlencoded');
  //   let body = new URLSearchParams();
  //   body.set('username', IqamaNumber);
  //   body.set('password', Password);
  //   body.set('grant_type', 'password');
  //   return this.http.post(
  //     `https://sandbox-tasheelweb-45f9fccbb93a.procco.net/rest/token`,
  //     body,
  //     {
  //       headers,
  //     }
  //   );
  // }
  GetTasheelToken() {
    return this.doGet('TasheelAuth/GetTasheelToken');
  }

  IBANcheck(body: any) {
    return this.doPost(
      'Application/IBANcheck?iban=' +
      body.iban +
      '&customerId=' +
      body.customerId,
      null
    );
  }

  GetCustomerInfo() {
    return this.doGet('Customer/GetCustomerInfo');
  }

  verifyEmailByOTP(otp: string) {
    return this.doPost('Customer/verify-email-by-otp', null, { params: { OTP: otp } })
  }

  verifyIvrByOTP(otp: string, appId: string) {
    return this.doPost('Application/loans/validateVerificationOtp', null, { params: { OTP: otp, appID: appId } });
  }

  resendVerificationOTP() {
    return this.doGet('Application/loans/resendVerificationOtp');
  }

  UploadApplicationDocumentsNext(body: any) {
    return this.doPost('Application/UploadApplicationDocumentsNext', body);
  }
  GetApplicationUpdloadDocuments(AppId: any) {
    return this.doGet(
      'Application/GetApplicationUpdloadDocuments?appId=' + AppId
    );
  }
  UpdateIBANAccount(body: any) {
    return this.doPost(
      'Application/UpdateIBANAccount?appId=' +
      body.appId +
      '&ibanAccount=' +
      body.ibanAccount,
      null
    );
  }

  DocumentSubmissionMethod(body: any) {
    return this.doPost(
      'Application/DocumentSubmissionMethod?id=' +
      body.id +
      '&IsDigital=' +
      body.IsDigital,
      null
    );
  }

  GetBranches(CityId: number) {
    let params = new HttpParams().set('CityId', CityId);
    return this.doGet('LookupAuth/GetBranches', { params });
  }

  GetRegionBranches(regionId: number) {
    let params = new HttpParams().set('regionId', regionId);
    return this.doGet('LookupAuth/GetRegionBranches', { params });
  }
  GetRegionBranchesWithNoSession(regionId: number) {
    let lang = this.session.CurrentLang.IsLeft ? 2 : 1;
    let params = new HttpParams().set('regionId', regionId)
      .set('languageId', lang);

    return this.doGet('Lookup/GetBranchesPerRegion', { params });
  }

  UpdateApplicationBranch(body: any) {
    return this.doPost(
      'Application/UpdateApplicationBranch?cityName=' +
      body.cityName +
      '&BranchId=' +
      body.BranchId,
      null
    );
  }
  GetSubmittedApplications() {
    return this.doGet('Application/GetSubmittedApplications');
  }

  GetCreditCards() {
    return this.doGet('CreditCard/GetCards');
  }

  getCardDetails(cardId: string) {
    let params = new HttpParams().set('CardID', cardId);
    return this.doGet('CreditCard/GetCard', {
      params,
    });
  }

  startCLIApplication(masterId: number, LimitAMT: number, contractNumber: string) {
    let params = new HttpParams()
      .set('masterId', masterId)
      .set('creditLimit', LimitAMT)
      .set('contractNumber', contractNumber);
    return this.doGet('Application/StartCLIApplication', { params });
  }

  updateCLIEmploymentInformation(employmentInformation: EmploymentInformation) {
    return this.doPost('Application/UpdateCLIEmploymentInformation', employmentInformation);
  }

  getCLIOffer(stagingId: string) {
    let params = new HttpParams()
      .set('stagingId', stagingId)
    return this.doGet('Application/GetCLIOffer', { params });
  }

  acceptCLIOffer(stagingId: string, amount: number) {
    let params = new HttpParams()
      .set('stagingId', stagingId)
      .set('Amount', amount);
    return this.doGet('Application/AcceptCLIOffer', { params });
  }

  StartJourneybyMerchant(MerchantId: any) {
    let params;
    params = new HttpParams().set('MerchantId', MerchantId);
    return this.doGet('Application/StartJourneybyMerchant', { params });
  }

  GetMerchants(
    LanguageID: number,
    categoryId: number,
    skip: number,
    take: number,
    search: string
  ) {
    let params = new HttpParams()
      .set('LanguageID', LanguageID)
      .set('categoryCode', categoryId)
      .set('skip', skip)
      .set('take', take)
      .set('search', search);
    return this.doGet('Lookup/GetMerchantsPerPage', {
      params,
    });
  }
  GetCategories(LanguageID: number) {
    let params = new HttpParams().set('LanguageID', LanguageID);
    return this.doGet('Lookup/GetMerchantCategories', {
      params,
    });
  }

  //http://localhost:5280/api/Lookup/GetMerchantCategories?LanguageID=2
  GetMerchantBranchs(RetailerID: number, LanguageID: number) {
    let params = new HttpParams()
      .set('RetailerID', RetailerID)
      .set('LanguageID', LanguageID);
    return this.doGet('Lookup/GetMerchantBranch', {
      params,
    });
  }

  GetCardSensitiveInfo(CardId: string) {
    let params = new HttpParams().set('CardId', CardId);
    return this.doGet('CreditCard/GetSensitiveInfo', {
      params,
    });
  }

  GetOffer(Tenure: number = 0, Amount: number = 0, AppId: string, isCard: boolean, fullOffer: boolean = false) {
    let params = new HttpParams()
      .set('Tenure', Tenure)
      .set('Amount', Amount)
      .set('AppId', AppId)
      .set('isCard', isCard)
      .set('fullOffer', fullOffer);
    return this.doGet('Application/GetOffer', {
      params,
    });
  }

  GetOfferLite(AppId: string) {
    let params = new HttpParams().set('AppId', AppId);
    return this.doGet('Application/GetOfferLite', {
      params,
    });
  }


  /** New offers (adjust offer)*/
  modifyLoanAmount(masterAppId: number, loanModel?: ModifyLoan) {
    let params = new HttpParams()
      .set('appId', masterAppId);
    return this.doPost('Application/modify-loan-offer', loanModel, { params }) as any;
  }

  isBundleEligible(masterAppId: number, loanAmount: number) {
    let params = new HttpParams()
      .set('appId', masterAppId)
      .set('amount', loanAmount);
    return this.doGet('Application/is-bundle-eligible', { params });
  }

  modifyBundleOffer(masterAppId: number, amount: number) {
    let params = new HttpParams()
      .set('appId', masterAppId)
      .set('cardLimit', amount);
    return this.doPost('Application/modify-bundle-offer', null, { params }) as any;
  }

  modifyCardOffer(masterAppId: number, cardOfferModel?: ModifyCardOffer) {
    let params = new HttpParams()
      .set('appId', masterAppId);
    return this.doPost('Application/modify-card-offer', cardOfferModel, { params }) as any;
  }

  modifyCombo(masterAppId: number, comboLoanModel?: ModifyComboOffer) {
    let params = new HttpParams()
      .set('appId', masterAppId);
    return this.doPost('Application/modify-combo-offer', comboLoanModel, { params }) as any;
  }

  acceptAdjustedOffer(masterAppId: number) {
    return this.doPost('Application/accept-offer', null, { params: { 'appId': masterAppId } });
  }

  /** New offers ends */


  GetUserInfo(AppId: string) {
    let params = new HttpParams().set('AppId', AppId)
    return this.doGet('Application/GetUserInfo', {
      params,
    });
  }

  RegenerateOffer(
    Tenure: number = 0,
    Amount: number = 0,
    AppId: string,
    isCCInclud: boolean
  ) {
    let params = new HttpParams()
      .set('Tenure', Tenure)
      .set('Amount', Amount)
      .set('isCCInclud', isCCInclud)
      .set('AppId', AppId);
    return this.doGet('Application/RegenerateOffer', {
      params,
    });
  }

  GetOfferTenures(Amount: number, AppId: string) {
    let params = new HttpParams().set('Amount', Amount).set('AppId', AppId);
    return this.doGet('Application/GetOfferTenures', {
      params,
    });
  }

  RejectCardOffer(
    AppId: string) {
    let params = new HttpParams()
      .set('AppId', AppId);
    return this.doGet('Application/RejectCardOffer', {
      params,
    });
  }

  AcceptOffer(
    AppId: string,
    Tenure: number = 0,
    Amount: number = 0,
    WalletAmount: number = -1,
    rejectCard: boolean = false
  ) {
    let params = new HttpParams()
      .set('AppId', AppId)
      .set('Tenure', Tenure)
      .set('Amount', Amount)
      .set('rejectCard', rejectCard);

    if (WalletAmount > -1) {
      params = new HttpParams()
        .set('AppId', AppId)
        .set('Tenure', Tenure)
        .set('Amount', Amount)
        .set('WalletAmount', WalletAmount);
    }

    return this.doGet('Application/AcceptOffer', {
      params,
    });
  }

  acceptCardOffer(
    AppId: string,
    Amount: number,
    FirstName: string,
    LastName: string,
    IsFullAMT: boolean = false
  ) {
    let params = new HttpParams()
      .set('AppId', AppId)
      .set('Amount', Amount)
      .set('FirstName', FirstName)
      .set('LastName', LastName)
      .set('IsFullAMT', IsFullAMT);
    return this.doGet('Application/AcceptCardOffer', {
      params,
    });
  }

  CustomizeCard(
    AppId: string,
    FirstName: string,
    LastName: string,
    IsFullAMT: boolean = false
  ) {
    let params = new HttpParams()
      .set('AppId', AppId)
      .set('FirstName', FirstName)
      .set('LastName', LastName)
      .set('IsFullAMT', IsFullAMT);
    return this.doGet('Application/CustomizeCard', {
      params,
    });
  }

  AcceptOfferLite(AppId: string) {
    let params = new HttpParams()
      .set('AppId', AppId);
    return this.doGet('Application/AcceptOfferLite', {
      params,
    });
  }

  saveEmploymentDetails(employmentInformation: EmploymentInformation) {
    return this.doPost('application/SaveEmploymentDetails', employmentInformation);
  }

  saveIBANAccount(AppId: string, ibanAccount: string) {
    let params = new HttpParams()
      .set('appId', AppId)
      .set('ibanAccount', ibanAccount);
    return this.doGet('Application/SaveIBANAccount', {
      params,
    });
  }

  GetRequiredDocument(AppId: string) {
    let params = new HttpParams().set('appId', AppId);
    return this.doGet('Application/GetDocuments', {
      params,
    });
  }

  SubmitDocuments(AppId: string) {
    let params = new HttpParams().set('appId', AppId);
    return this.doGet('Application/SubmitDocument', {
      params,
    });
  }

  SubmitAppInStore(AppId: string) {
    let params = new HttpParams().set('appId', AppId);
    return this.doGet('Application/SubmitAppInStore', {
      params,
    });
  }

  VerifyCitc(AppId: string, mobile: string) {
    let params = new HttpParams()
      .set('AppId', AppId)
      .set('MobileNumber', mobile);
    return this.doGet('Application/VerifyCITC', {
      params,
    });
  }

  VerifyAbsher(AppId: string, otp: string) {
    let params = new HttpParams().set('AppId', AppId).set('OTP', otp);
    return this.doGet('Application/VerifyAbsher', {
      params,
    });
  }

  SendAbsherOTP(AppId: string) {
    let params = new HttpParams().set('AppId', AppId);
    return this.doGet('Application/SendAbsherOTP', {
      params,
    });
  }

  canApply(productId: number) {
    let params = new HttpParams().set('productId', productId);
    return this.doGet('Dashboard/can-have-new-application', { params });
  }

  GetCustomerBoard() {
    return this.doGet('Dashboard/GetCustomerBoard');
  }

  getCustomerNotificationList() {
    return this.doGet('Customer/get-customer-notifications');
  }

  updateNotificationReadStatus(notificationId: any) {
    return this.doPost('Customer/read-customer-notifications', null, { params: { Id: notificationId } });
  }

  recordFraudDisplay() {
    return this.doPost('Dashboard/RecordFraudDisplay', null);
  }

  GetReminders() {
    return this.doGet('Dashboard/GetReminders');
  }

  CardActivate(cardID: string, pinNumber: string) {
    return this.doPost('CreditCard/Activate', { cardID, pinNumber });
  }

  ChangePin(cardID: string, pinNumber: string) {
    return this.doPost('CreditCard/ChangePin', { cardID, pinNumber });
  }

  ResetPin(cardID: string, pinNumber: string) {
    return this.doPost('CreditCard/ResetPin', { cardID, pinNumber });
  }

  CardBlock(cardID: string) {
    let params = new HttpParams().set('cardID', cardID);
    return this.doGet('CreditCard/CardBlock', { params });
  }

  CardFreeze(cardID: string) {
    let params = new HttpParams().set('cardID', cardID);
    return this.doGet('CreditCard/CardFreeze', { params });
  }

  CardUnFreeze(cardID: string) {
    let params = new HttpParams().set('cardID', cardID);
    return this.doGet('CreditCard/CardUnFreeze', { params });
  }

  GetTestPdfDocuments() {
    let params = new HttpParams().set('DocumentID', 50131);
    return this.doGet('Test/GetDocument', { params });
  }

  GetLoanDocuments(CardID: string) {
    let params = new HttpParams().set('CardID', CardID);
    return this.doGet('CreditCard/GetDocuments', { params });
  }

  downloadDocument(DocumentID: string) {
    let params = new HttpParams().set('DocumentID', DocumentID);
    return this.doGet('Dashboard/GetDocument', { params });
  }

  // GetDocumentBase64(DocumentID: string) {
  //   debugger;
  //   let params = new HttpParams().set('DocumentID', DocumentID);
  //   return this.doGet('Dashboard/GetDocument', { params });
  // }

  downloadQuotationDocument(AppId: string, Tenure: number, Amount: number) {
    let params = new HttpParams()
      .set('AppId', AppId)
      .set('Tenure', Tenure)
      .set('Amount', Amount);
    return this.download('Application/GetQuotationFile', { params });
  }

  GetQuotationInfo(AppId: string) {
    let params = new HttpParams().set('AppId', AppId);
    return this.doGet('Application/GetQuotationInfo', { params });
  }

  AcceptQuotation(AppId: string) {
    let params = new HttpParams().set('AppId', AppId);
    return this.doGet('Application/AcceptQuotation', { params });
  }

  openSayenDocument() {
    return this.download('Dashboard/DownloadSayenDoc', {});
  }

  getTransactionHistory(cardID: string, dateFrom?: Date, dateTo?: Date, transactionType?: string) {
    return this.doPost('Orders', {
      cardId : cardID,
      startDate : dateFrom,
      endDate : dateTo,
    });
  }

  getEppDetails(docId : string){
    return this.doGet('Orders/details', { params : {docId : docId}});
  }

  getPaymentPlan(docId : string){
    return this.doGet('Orders/payment-plan', { params : {docId : docId}});
  }
  confirmEppPlan(docId : string, tenure : number){
    return this.doPost('Orders/change-tenure', { DocId : docId, Tenure : tenure}, { params : {docId : docId} });
  }

  GetSubCardRules(CardID: string) {
    let params = new HttpParams().set('CardID', CardID);
    return this.doGet('CreditCard/GetSuppCardRules', { params });
  }

  addSuppCard(body: any) {
    return this.doPost('CreditCard/AddSupplementaryCard', body);
  }

  Getloans() {
    return this.doGet('Loan/Getloans');
  }

  GetBankList() {
    return this.doGet('LookupAuth/GetBankList');
  }

  GetLiabilityLetter(AppId: string, bank?: string) {
    let params = new HttpParams().set('AppId', AppId);

    const cleanedBank = bank?.trim();
    if (cleanedBank)
      params = params.set('bank', cleanedBank);

    return this.doGet('Loan/GetLiabilityLetter', { params });
  }

  DownloadLiabilityLetter(AppId: string, bank?: string) {
    let params = new HttpParams().set('AppId', AppId);

    const cleanedBank = bank?.trim();
    if (cleanedBank)
      params = params.set('bank', cleanedBank);

    return this.download('Loan/DownloadLiabilityLetter', { params });
  }

  SendLiabilityLetterEmail(AppId: string, bank?: string) {
    let params = new HttpParams().set('AppId', AppId);

    const cleanedBank = bank?.trim();
    if (cleanedBank)
      params = params.set('bank', cleanedBank);

    return this.doGet('Loan/SendLiabilityLetterEmail', { params });
  }

  GetAppDoc(AppId: string) {
    let params = new HttpParams().set('AppId', AppId);
    return this.doGet('Dashboard/GetAppDoc', { params });
  }

  GetPayments(ref: string) {
    let params = new HttpParams().set('FIN_ACCOUNT_NUMBER', ref);
    return this.doGet('loan/GetPayments', { params });
  }

  SetLimitSuppCard(CardID: string, Amount: string) {
    let params = new HttpParams().set('CardID', CardID).set('Amount', Amount);
    return this.doGet('CreditCard/SetLimitSuppCard', { params });
  }

  GetCityByLocation(latitude: number, logitude: number) {
    let params = new HttpParams()
      .set('latitude', latitude)
      .set('logitude', logitude);
    return this.doGet('LookupAuth/GetCity', { params });
  }

  GetNearCity(latitude: number, logitude: number) {
    let params = new HttpParams()
      .set('latitude', latitude)
      .set('logitude', logitude);
    return this.doGet('Application/GetNearCity', { params });
  }

  GetStorebyLocation(latitude: number, logitude: number) {
    let params = new HttpParams()
      .set('latitude', latitude)
      .set('logitude', logitude);
    return this.doGet('Application/GetStorebyLocation', { params });
  }

  geolocate() {
    let apiURL = 'https://www.googleapis.com/geolocation/v1/geolocate';
    const params = new HttpParams().set('key', 'AIzaSyCdlr9GQvmHXOotp2Klp0zriO4jTYwLcYE'); // Replace with your Google API key
    var body = {};
    return this.http.post(`${apiURL}?${params.toString()}`, body);
  }

  getApplicationRules(ProductId: number, AppId: string = '', PId?: number) {
    let params = new HttpParams().set('ProductId', ProductId);
    if (PId)
      params = params.append('PId', PId);
    if (AppId)
      params = params.append('AppId', AppId);
    return this.doGet('Application/GetApplicationRules', { params });
  }

  UpdateJobTitles(AppId: string, JobTitleCode: number) {
    let params = new HttpParams().set('AppId', AppId).set('JobTitleCode', JobTitleCode);
    return this.doGet('Application/UpdateJobTitles', { params });
  }

  EmploymentValidate(AppId: string, EmploymentType: number) {
    let params = new HttpParams().set('AppId', AppId)
      .set('EmploymentType', EmploymentType);
    return this.doGet('Application/EmploymentValidate', { params });
  }

  ValidateReferralCode(code: string) {
    let params = new HttpParams().set('ReferralCode', code);
    return this.doGet('Application/ValidateReferralCode', { params });
  }

  getOpenBankingIbans() {
    return this.doGet('Application/GetOpenBankingIbans');
  }

  ValidateIban(iban: string, stagingId: string) {
    let params = new HttpParams().set('iban', iban).set('stagingId', stagingId);
    return this.doGet('Application/ValidateIban', { params });
  }

  confirmAnonymousEmail(token: string) {
    let params = new HttpParams().set('token', token);
    return this.doGet('Customer/ConfirmEmailAddress', { params });
  }

  GetDigitalSigniture(AppId: string) {
    let params = new HttpParams().set('AppId', AppId);
    return this.doGet('Application/GetDigitalSigniture', { params });
  }

  SayenRegister(AppId: string) {
    let params = new HttpParams().set('AppId', AppId);
    return this.doGet('Application/SayenRegister', { params });
  }

  DigitalSignitureRead(AppId: string) {
    let params = new HttpParams().set('AppId', AppId);
    return this.doGet('Application/DigitalSignitureRead', { params });
  }

  GetPromissoryNotes(AppId: string) {
    let params = new HttpParams().set('AppId', AppId);
    return this.doGet('Application/GetPromissoryNotes', { params });
  }

  SubmitPromissoryNote(AppId: string) {
    let params = new HttpParams().set('AppId', AppId);
    return this.doGet('Application/SubmitPromissoryNote', { params });
  }

  GetNafathAuthenticateKey(AppId: string) {
    let params = new HttpParams().set('AppId', AppId);
    return this.doGet('Application/GetNafathAuthenticateKey', { params });
  }

  checkCardExistence(data: { bin: string, expiryMonth: string, expiryYear: string, last4Digits: string, token: string, AppId: string, fingerprint: string }) {
    return this.doPost('Checkout/CheckCardExists', data);
  }

  CardTokenization(token: string, AppId: string) {
    let params = new HttpParams().set('token', token).set('AppId', AppId);
    return this.doGet('Checkout/CardTokenization', { params });
  }

  CheckoutSuccess(SessionId: string, AppId: string, isPrimary: boolean = false) {
    let params = new HttpParams().set('SessionId', SessionId).set('AppId', AppId).set('isPrimary', isPrimary);
    return this.doGet('Checkout/Success', { params });
  }

  CheckoutFailure(sessionId: string, appId: string): Observable<CommonResponse<CheckoutFailureReason>> {
    let params = new HttpParams().set('sessionId', sessionId).set('appId', appId);
    return this.doGet('Checkout/CheckoutFail', { params });
  }

  PaySuccess(SessionId: string) {
    let params = new HttpParams().set('SessionId', SessionId);
    return this.doGet('Checkout/PaySuccess', { params });
  }

  Checkout3DSSuccess(SessionId: string, AppId: string) {
    let params = new HttpParams().set('SessionId', SessionId).set('AppId', AppId);
    return this.doGet('Checkout/Checkout3DSSuccess', { params });
  }

  PaymentConfirmation(SessionId: string) {
    let params = new HttpParams().set('SessionId', SessionId);
    return this.doGet('Checkout/PaymentConfirmation', { params });
  }
  GetCards() {
    return this.doGet('Checkout/GetCards');
  }

  changeMobileRequest(Mobile: any) {
    let params = new HttpParams().set('mobile', Mobile);
    return this.doGet('Customer/ChangeMobileRequest', { params });
  }

  getNafathMobileDetails(generateNew: boolean) {
    let params = new HttpParams().set('generateNew', generateNew);
    return this.doPost('Customer/Mobile/GetNafathDetails', null, { params });
  }

  validateMobileChangeOTP(otp: any) {
    return this.doPost('Customer/Mobile/ValidateOtp', { OTPValue: otp });
  }

  resendMobileChangeOTP() {
    return this.doGet('Customer/Mobile/ResendOTP');
  }

  EmailChange(email: string) {
    let params = new HttpParams().set('email', email);
    return this.doGet('Customer/ChangeEmailRequest', { params });
  }

  GetAccountInfo() {
    return this.doGet('Customer/GetCustomerInfo');
  }

  ChangeLanguage() {
    return this.doGet('Customer/ChangeLanguage');
  }

  UpdateCustomerIncome(income: any) {
    return this.doGet('Customer/UpdateCustomerIncome?income=' + income);
  }

  checkAppForeignAccess(appId: string) {
    let params = new HttpParams().set('appId', appId);
    return this.doPost('Application/CheckAppForeignAccess', null, { params });
  }

  // get application default values
  GetApplication(AppId: string) {
    let params = new HttpParams().set('AppId', AppId);
    return this.doGet('Application/GetApplication', { params });
  }

  GetEarlySettlement(AppId: number) {
    let params = new HttpParams().set('AppId', AppId);
    return this.doGet('loan/GetEarlySettlement', { params });
  }

  GetT2TransactionHistory(cardID: string, dateFrom: Date, dateTo: Date) {
    let body = {
      cardID,
      dateFrom,
      dateTo,
    };
    return this.doPost('CreditCard/GetT2TransactionHistory', body, {});
  }

  DownloadT2TransactionHistory(cardID: string, dateFrom: Date, dateTo: Date) {
    let body = {
      cardID,
      dateFrom,
      dateTo,
    };
    return this.downloadPostRequest('CreditCard/DownloadT2TransactionHistory', body, {});
  }

  GetTransactionDetail(CardID: string, DocId: string, HasDetails: boolean) {
    let params = new HttpParams().set('cardId', CardID).set('DocId', DocId).set('HasDetails', HasDetails);
    return this.doGet('CreditCard/GetTransactionDetail', { params });
  }

  GetInstallmentTenure(DocId: string) {
    let params = new HttpParams().set('DocId', DocId);
    return this.doGet('CreditCard/GetInstallmentTenure', { params });
  }

  GetProfitApr(transactionAmount: number, tenure: number, profitRate: number, transDate: string) {
    let params = new HttpParams()
      .set('transactionAmount', transactionAmount)
      .set('tenure', tenure)
      .set('profitRate', profitRate)
      .set('transDate', transDate);
    return this.doGet('CreditCard/GetProfitApr', { params });
  }

  ChangeCreditCardTenure(tenure: number, DocID: string, APR: string) {
    let params = new HttpParams()
      .set('tenure', tenure)
      .set('DocID', DocID)
      .set('APR', APR);
    return this.doGet('CreditCard/ChangeTenure', { params });
  }

  GetClearanceLetter(AppId: string) {
    let params = new HttpParams().set('AppId', AppId);
    return this.doGet('Loan/GetClearanceLetter', { params });
  }

  DownloadClearanceLetter(AppId: string) {
    let params = new HttpParams().set('AppId', AppId);
    return this.download('Loan/DownloadClearanceLetter', { params });
  }

  ChangeAlternateMobileNo(mobileNumber: string, AppId: string) {
    let params = new HttpParams().set('AlternativeMobile', mobileNumber)
      .set('appId', AppId);
    return this.doGet('Application/SaveAlternateMobile', { params });
  }

  CancelAlternateMobileNo(AppId: string) {
    let params = new HttpParams()
      .set('appId', AppId);
    return this.doGet('Application/CancelAlternateMobile', { params });
  }

  RegisterFCM(Token: any) {
    let params = new HttpParams().set('Token', Token);
    return this.doGet('FCM/RegisterFCM', {
      params,
    });
  }

  PermissionToServe(body: any) {
    //return this.doPost('Customer/PermissionToServe', body);
    let params = new HttpParams().set('RequestId', body.RequestId)
      .set('status', body.status);
    return this.doGet(
      'Customer/PermissionToServe',
      { params }
    );
  }

  IsPermissionToServeValid(RequestId: any) {
    let params = new HttpParams().set('RequestId', RequestId);
    return this.doGet(
      'Customer/IsPermissionToServeValid',
      { params }
    );
  }

  CancelApplication(AppId: string) {
    let params = new HttpParams().set('AppId', AppId);
    return this.doGet('Application/CancelApplication', { params });
  }

  AddcheckoutCard(AppId: string, CardId: any) {
    let params = new HttpParams().set('AppId', AppId)
      .set('CardId', CardId);
    return this.doGet('Application/AddcheckoutCard', { params });
  }

  CheckoutCardInActive(CardID: string) {
    let params = new HttpParams().set('CardID', CardID);
    return this.doGet('Checkout/CardInActive', { params });
  }
  Pay(body: any) {
    return this.doPost('Checkout/Pay', body);
  }

  GetUnifiedContracts() {
    return this.doGet('Application/GetUnifiedContracts');
  }

  SignUnifiedContract(MasterAppId: number) {
    let params = new HttpParams().set('MasterAppId', MasterAppId);
    return this.doGet('Application/SignUnifiedContract', { params });
  }

  GenerateUnifedContract(MasterAppId: number) {
    let params = new HttpParams().set('MasterAppId', MasterAppId);
    return this.doGet('Application/GenerateUnifedContract', { params });
  }

  DownloadUnifiedContract(masterAppId: number) {
    let params = new HttpParams().set('MasterAppId', masterAppId);
    return this.doGet('Application/DownloadUnifiedContract', { params });
  }

  GetRejectedReason(AppId: string) {
    let params = new HttpParams().set('AppId', AppId);
    return this.doGet('Application/GetRejectedReason', { params });
  }

  CardStatementDownload(CardID: string, DateFrom: string, IsPrimary: boolean) {
    let body = {
      CardID,
      DateFrom,
      IsPrimary
    };
    return this.downloadPostRequest('CreditCard/CardStatmentDownload', body, {});
  }

  LoanStatementDownload(FIN_ACCOUNT_NUMBER: string) {
    let body = { FIN_ACCOUNT_NUMBER };
    return this.downloadPostRequest('loan/DownLoadLoanPayments', body, {});
  }

  CaptureUTMParamsAnalytics(
    utm_source: string | null,
    utm_medium: string | null,
    utm_campaign: string | null,
    utm_content: string | null,
    utm_term: string | null,
    app_client_id: string | null,
    gclid: string | null,
    client_id: string | null,
    session_id: string | null,
    fbp: string | null,
    fbc: string | null
  ) {
    return this.doPost('Analytics/CaptureUTMParamsAnalytics', {
      utm_source: utm_source,
      utm_medium: utm_medium,
      utm_campaign: utm_campaign,
      utm_content: utm_content,
      utm_term: utm_term,
      app_client_id: app_client_id,
      gclid: gclid,
      client_id: client_id,
      session_id: session_id,
      fbp: fbp,
      fbc: fbc
    });
  }

  GetLeanListOfBanks() {
    return this.doGet('OpenBanking/LeanListOfBanks');
  }

  CreateLeanCustomer(CivilId: string) {
    let params = new HttpParams().set('CivilId', CivilId);
    return this.doGet('OpenBanking/CreateLeanCustomer', { params });
  }

  GetOpenBankingAppRules(civilId: string, entityId: string) {
    let params = new HttpParams()
      .set('civilId', civilId)
      .set('entityId', entityId);
    return this.doGet('OpenBanking/GetOpenBankingAppRules', { params });
  }

  CreateOpenBankingApp(body: any) {
    return this.doPost('OpenBanking/CreateOpenBankingApp', body);
  }

  logUserTrackingEvent(data: any) {
    return this.sendBeacon(this.session.uteUrl + 'ute/screen-tracking', JSON.stringify(data));
  }

  postUserTrackingEvent(data: any) {
    return this.http.post(this.session.uteUrl + 'ute/screen-tracking', data);
  }

  SendOTP_V2(OtpType: string) {
    return this.doPost(`OTP/SendOTP/${OtpType}`, null);
  }

  validateOtp_V2(data: { OTP: number, OtpType: String }) {
    return this.doPost('OTP/ValidateOTP', data);
  }

  regeneratePN(stagingId: string) {
    let params = new HttpParams().set('stagingId', stagingId);
    return this.doPost(`Application/RegeneratePromissoryNote`, null, { params });
  }

  captureGeolocationLeads(data: { failureTypeId: number, productId?: number, pId?: number }) {
    return this.doPost('Application/geolocation-report', null, { params: data });
  }

  async getCountry(coords: { latitude: number, longitude: number }): Promise<any> {
    let params = new HttpParams()
      .set('latitude', coords.latitude)
      .set('longitude', coords.longitude);
    return await this.doGet('eligibility/get-country', { params }).toPromise();
  }

  getReferralDetails(body: { civilId: string; referralId: string ; CheckIsCustomerExisting?:boolean }) {
    return this.http.post<any>(`${this.session.ApiUrl}snb/GetReferralDetails`, body);
  }

  getSnbCivilIdAction(body: { civilId: string }) {
    return this.http.post<any>(this.session.ApiUrl + 'snb/CivilId', 
      body,
    );
  }

  getRemainingTimeToActivateCard(appId : string){
    return this.doGet('CreditCard/remaining-seconds', { params : {stagingId : appId}});
  }

  getNearestBranch(latitude?: number, longitude?: number){
    let params = new HttpParams()
      .set('latitude', latitude ?? 0)
      .set('longitude', longitude ?? 0);
    return this.doGet('CreditCard/GetNearestBranch', { params });
  }

  requestIVR(stagingId: string) {
    return this.doGet('application/request-ivr-call', { params : {'stagingId' : stagingId}});
  }
}
